// src/components/cityCoordinates.js
// City coordinates for distance calculation fallback when zip code API doesn't return lat/lon

const cityCoordinates = {
  // ========================================
  // NORTHERN CALIFORNIA - PRIMARY CLINICS
  // ========================================
  'Redding': { lat: 40.5865, lon: -122.3917 },
  'Eureka': { lat: 40.8021, lon: -124.1637 },
  'Red Bluff': { lat: 40.1785, lon: -122.2358 },
  'Fairfield': { lat: 38.2494, lon: -122.0399 },
  'Hollister': { lat: 36.8525, lon: -121.4016 },
  'Monterey': { lat: 36.6002, lon: -121.8947 },
  'Salinas': { lat: 36.6777, lon: -121.6555 },
  
  // ========================================
  // REDDING AREA & SHASTA COUNTY
  // ========================================
  'Anderson': { lat: 40.4482, lon: -122.2978 },
  'Shasta Lake': { lat: 40.6801, lon: -122.3717 },
  'Cottonwood': { lat: 40.3854, lon: -122.2786 },
  'Palo Cedro': { lat: 40.5779, lon: -122.2361 },
  'Bella Vista': { lat: 40.6501, lon: -122.2289 },
  'Millville': { lat: 40.5607, lon: -122.1500 },
  'Igo': { lat: 40.4332, lon: -122.5261 },
  'Ono': { lat: 40.4701, lon: -122.6119 },
  'Shingletown': { lat: 40.4907, lon: -121.8894 },
  'Whitmore': { lat: 40.6340, lon: -121.9129 },
  
  // ========================================
  // RED BLUFF & TEHAMA COUNTY
  // ========================================
  'Corning': { lat: 39.9279, lon: -122.1792 },
  'Tehama': { lat: 40.0254, lon: -122.1208 },
  'Los Molinos': { lat: 40.0218, lon: -122.0969 },
  'Proberta': { lat: 40.0082, lon: -122.1753 },
  'Gerber': { lat: 40.0540, lon: -122.1497 },
  'Manton': { lat: 40.4365, lon: -121.8568 },
  'Red Bank': { lat: 39.9957, lon: -122.3489 },
  
  // ========================================
  // EUREKA & HUMBOLDT COUNTY
  // ========================================
  'Arcata': { lat: 40.8665, lon: -124.0828 },
  'McKinleyville': { lat: 40.9465, lon: -124.1006 },
  'Blue Lake': { lat: 40.8829, lon: -123.9839 },
  'Trinidad': { lat: 41.0590, lon: -124.1428 },
  'Fortuna': { lat: 40.5982, lon: -124.1572 },
  'Rio Dell': { lat: 40.4993, lon: -124.1067 },
  'Scotia': { lat: 40.4818, lon: -124.1011 },
  'Ferndale': { lat: 40.5760, lon: -124.2639 },
  'Loleta': { lat: 40.6418, lon: -124.2261 },
  'Garberville': { lat: 40.1001, lon: -123.7942 },
  'Redway': { lat: 40.1201, lon: -123.8239 },
  'Willow Creek': { lat: 40.9396, lon: -123.6311 },
  'Hoopa': { lat: 41.0524, lon: -123.6725 },
  
  // ========================================
  // CHICO & BUTTE COUNTY
  // ========================================
  'Chico': { lat: 39.7285, lon: -121.8375 },
  'Oroville': { lat: 39.5138, lon: -121.5564 },
  'Paradise': { lat: 39.7596, lon: -121.6219 },
  'Gridley': { lat: 39.3638, lon: -121.6936 },
  'Biggs': { lat: 39.4124, lon: -121.7127 },
  'Durham': { lat: 39.6468, lon: -121.8061 },
  'Magalia': { lat: 39.8121, lon: -121.5783 },
  
  // ========================================
  // SACRAMENTO VALLEY
  // ========================================
  'Sacramento': { lat: 38.5816, lon: -121.4944 },
  'Davis': { lat: 38.5449, lon: -121.7405 },
  'West Sacramento': { lat: 38.5805, lon: -121.5302 },
  'Elk Grove': { lat: 38.4088, lon: -121.3716 },
  'Folsom': { lat: 38.6779, lon: -121.1760 },
  'Roseville': { lat: 38.7521, lon: -121.2880 },
  'Rocklin': { lat: 38.7907, lon: -121.2358 },
  'Lincoln': { lat: 38.8916, lon: -121.2930 },
  'Auburn': { lat: 38.8966, lon: -121.0770 },
  'Placerville': { lat: 38.7296, lon: -120.7985 },
  'Rancho Cordova': { lat: 38.5891, lon: -121.3025 },
  'Citrus Heights': { lat: 38.7071, lon: -121.2810 },
  'Carmichael': { lat: 38.6171, lon: -121.3283 },
  'Fair Oaks': { lat: 38.6463, lon: -121.2644 },
  'Orangevale': { lat: 38.6788, lon: -121.2258 },
  
  // ========================================
  // SOLANO COUNTY & SURROUNDING
  // ========================================
  'Vacaville': { lat: 38.3566, lon: -121.9877 },
  'Vallejo': { lat: 38.1041, lon: -122.2566 },
  'Benicia': { lat: 38.0494, lon: -122.1586 },
  'Suisun City': { lat: 38.2382, lon: -122.0402 },
  'Dixon': { lat: 38.4452, lon: -121.8233 },
  'Rio Vista': { lat: 38.1744, lon: -121.6905 },
  'Winters': { lat: 38.5246, lon: -121.9708 },
  
  // ========================================
  // YOLO COUNTY
  // ========================================
  'Esparto': { lat: 38.6921, lon: -122.0194 },
  'Capay': { lat: 38.7088, lon: -122.0561 },
  'Brooks': { lat: 38.7663, lon: -122.1561 },
  'Guinda': { lat: 38.8368, lon: -122.1886 },
  'Rumsey': { lat: 38.8846, lon: -122.2394 },
  'Dunnigan': { lat: 38.8863, lon: -121.9683 },
  'Zamora': { lat: 38.8074, lon: -121.9144 },
  'Madison': { lat: 38.6788, lon: -121.9644 },
  'Yolo': { lat: 38.7285, lon: -121.7997 },
  
  // ========================================
  // LAKE COUNTY
  // ========================================
  'Lakeport': { lat: 39.0429, lon: -122.9158 },
  'Clearlake': { lat: 38.9582, lon: -122.6266 },
  'Middletown': { lat: 38.7496, lon: -122.6133 },
  'Lower Lake': { lat: 38.9099, lon: -122.6097 },
  'Kelseyville': { lat: 38.9779, lon: -122.8408 },
  'Nice': { lat: 39.1188, lon: -122.8447 },
  'Lucerne': { lat: 39.0488, lon: -122.8469 },
  
  // ========================================
  // MENDOCINO COUNTY
  // ========================================
  'Ukiah': { lat: 39.1502, lon: -123.2078 },
  'Willits': { lat: 39.4096, lon: -123.3561 },
  'Fort Bragg': { lat: 39.4457, lon: -123.8053 },
  'Point Arena': { lat: 38.9088, lon: -123.6931 },
  'Mendocino': { lat: 39.3077, lon: -123.7997 },
  'Laytonville': { lat: 39.6882, lon: -123.4828 },
  
  // ========================================
  // BAY AREA
  // ========================================
  // San Francisco & Peninsula
  'San Francisco': { lat: 37.7749, lon: -122.4194 },
  'Daly City': { lat: 37.6879, lon: -122.4702 },
  'San Bruno': { lat: 37.6305, lon: -122.4111 },
  'South San Francisco': { lat: 37.6547, lon: -122.4077 },
  'Pacifica': { lat: 37.6138, lon: -122.4869 },
  'San Mateo': { lat: 37.5630, lon: -122.3255 },
  'Burlingame': { lat: 37.5844, lon: -122.3661 },
  'Millbrae': { lat: 37.5985, lon: -122.3872 },
  'Redwood City': { lat: 37.4852, lon: -122.2364 },
  'Menlo Park': { lat: 37.4530, lon: -122.1817 },
  'Palo Alto': { lat: 37.4419, lon: -122.1430 },
  'Mountain View': { lat: 37.3861, lon: -122.0839 },
  
  // East Bay
  'Oakland': { lat: 37.8044, lon: -122.2712 },
  'Berkeley': { lat: 37.8715, lon: -122.2730 },
  'Alameda': { lat: 37.7652, lon: -122.2416 },
  'Fremont': { lat: 37.5485, lon: -121.9886 },
  'Hayward': { lat: 37.6688, lon: -122.0808 },
  'San Leandro': { lat: 37.7249, lon: -122.1561 },
  'Union City': { lat: 37.5933, lon: -122.0438 },
  'Newark': { lat: 37.5297, lon: -122.0402 },
  'Pleasanton': { lat: 37.6624, lon: -121.8747 },
  'Livermore': { lat: 37.6819, lon: -121.7680 },
  'Dublin': { lat: 37.7022, lon: -121.9358 },
  'Castro Valley': { lat: 37.6941, lon: -122.0863 },
  'Walnut Creek': { lat: 37.9101, lon: -122.0652 },
  'Concord': { lat: 37.9780, lon: -122.0311 },
  'Pleasant Hill': { lat: 37.9480, lon: -122.0608 },
  'Martinez': { lat: 38.0193, lon: -122.1341 },
  'Antioch': { lat: 38.0049, lon: -121.8058 },
  'Pittsburg': { lat: 38.0280, lon: -121.8847 },
  'Brentwood': { lat: 37.9318, lon: -121.6958 },
  'San Ramon': { lat: 37.7799, lon: -121.9780 },
  'Danville': { lat: 37.8216, lon: -121.9999 },
  'Richmond': { lat: 37.9358, lon: -122.3477 },
  'El Cerrito': { lat: 37.9161, lon: -122.3108 },
  'Albany': { lat: 37.8869, lon: -122.2977 },
  'Emeryville': { lat: 37.8313, lon: -122.2855 },
  
  // South Bay & Silicon Valley
  'San Jose': { lat: 37.3382, lon: -121.8863 },
  'Santa Clara': { lat: 37.3541, lon: -121.9552 },
  'Sunnyvale': { lat: 37.3688, lon: -122.0363 },
  'Cupertino': { lat: 37.3230, lon: -122.0322 },
  'Campbell': { lat: 37.2872, lon: -121.9499 },
  'Los Gatos': { lat: 37.2358, lon: -121.9619 },
  'Saratoga': { lat: 37.2638, lon: -122.0230 },
  'Milpitas': { lat: 37.4283, lon: -121.9066 },
  'Santa Cruz': { lat: 36.9741, lon: -122.0308 },
  'Watsonville': { lat: 36.9101, lon: -121.7569 },
  'Capitola': { lat: 36.9752, lon: -121.9535 },
  'Scotts Valley': { lat: 37.0511, lon: -122.0147 },
  'Gilroy': { lat: 37.0058, lon: -121.5682 },
  'Morgan Hill': { lat: 37.1305, lon: -121.6544 },
  'Los Altos': { lat: 37.3688, lon: -122.1141 },
  
  // North Bay
  'San Rafael': { lat: 37.9735, lon: -122.5311 },
  'Novato': { lat: 38.1074, lon: -122.5697 },
  'Petaluma': { lat: 38.2324, lon: -122.6366 },
  'Santa Rosa': { lat: 38.4404, lon: -122.7141 },
  'Rohnert Park': { lat: 38.3397, lon: -122.7011 },
  'Cotati': { lat: 38.3274, lon: -122.7094 },
  'Sebastopol': { lat: 38.4021, lon: -122.8239 },
  'Healdsburg': { lat: 38.6104, lon: -122.8692 },
  'Windsor': { lat: 38.5471, lon: -122.8164 },
  'Cloverdale': { lat: 38.8055, lon: -123.0175 },
  'Napa': { lat: 38.2975, lon: -122.2869 },
  'St. Helena': { lat: 38.5052, lon: -122.4703 },
  'Calistoga': { lat: 38.5788, lon: -122.5797 },
  'American Canyon': { lat: 38.1749, lon: -122.2608 },
  'Yountville': { lat: 38.4013, lon: -122.3608 },
  'Sonoma': { lat: 38.2919, lon: -122.4580 },
  
  // ========================================
  // CENTRAL CALIFORNIA
  // ========================================
  'Fresno': { lat: 36.7378, lon: -119.7871 },
  'Clovis': { lat: 36.8252, lon: -119.7029 },
  'Madera': { lat: 36.9613, lon: -120.0607 },
  'Modesto': { lat: 37.6391, lon: -120.9969 },
  'Turlock': { lat: 37.4947, lon: -120.8466 },
  'Ceres': { lat: 37.5949, lon: -120.9577 },
  'Riverbank': { lat: 37.7360, lon: -120.9355 },
  'Stockton': { lat: 37.9577, lon: -121.2908 },
  'Lodi': { lat: 38.1302, lon: -121.2722 },
  'Tracy': { lat: 37.7397, lon: -121.4252 },
  'Manteca': { lat: 37.7974, lon: -121.2160 },
  'Merced': { lat: 37.3022, lon: -120.4830 },
  'Atwater': { lat: 37.3477, lon: -120.6090 },
  'Livingston': { lat: 37.3866, lon: -120.7238 },
  'Visalia': { lat: 36.3302, lon: -119.2921 },
  'Tulare': { lat: 36.2077, lon: -119.3473 },
  'Hanford': { lat: 36.3274, lon: -119.6457 },
  'Porterville': { lat: 36.0652, lon: -119.0168 },
  'Delano': { lat: 35.7688, lon: -119.2471 },
  'San Luis Obispo': { lat: 35.2828, lon: -120.6596 },
  'Paso Robles': { lat: 35.6266, lon: -120.6909 },
  'Atascadero': { lat: 35.4894, lon: -120.6707 },
  'King City': { lat: 36.2127, lon: -121.1260 },
  'Gonzales': { lat: 36.5066, lon: -121.4444 },
  'Soledad': { lat: 36.4247, lon: -121.3263 },
  'Greenfield': { lat: 36.3208, lon: -121.2430 },
  
  // ========================================
  // SOUTHERN CALIFORNIA
  // ========================================
  'Los Angeles': { lat: 34.0522, lon: -118.2437 },
  'San Diego': { lat: 32.7157, lon: -117.1611 },
  'Pomona': { lat: 34.0551, lon: -117.7500 }, // Covers 91768
  'Riverside': { lat: 33.9533, lon: -117.3962 },
  'San Bernardino': { lat: 34.1083, lon: -117.2898 },
  'Anaheim': { lat: 33.8366, lon: -117.9143 },
  'Santa Ana': { lat: 33.7455, lon: -117.8677 },
  'Irvine': { lat: 33.6846, lon: -117.8265 },
  'Bakersfield': { lat: 35.3733, lon: -119.0187 },
  'Long Beach': { lat: 33.7701, lon: -118.1937 },
  'Ontario': { lat: 34.0633, lon: -117.6509 },
  'Rancho Cucamonga': { lat: 34.1064, lon: -117.5931 }
};

export default cityCoordinates;







